import { Slot, component$ } from '@builder.io/qwik';
import ArticleCoverImage from '../ArticleCover/ArticleCoverImage';

export default component$(() => {
  return (
    <header
      class={`relative z-10 w-full text-center bg-black text-white
    flex flex-col md:flex-row md:items-center lg:mt-[-2px]`}
    >
      <div class='flex justify-center items-center flex-1'>
        <div class='my-6 mx-5 lg:w-3/4 flex flex-col justify-between'>
          <Slot />
        </div>
      </div>
      <ArticleCoverImage />
    </header>
  );
});
